import { getMessageFactory } from "../getCaxaWebSocket.js";
const createOrderFile = getMessageFactory({
  code: "CREATE_ORDER_FILE"
});
export { createOrderFile };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/createOrderFile.js